<template>
<div class="chapter">
<div class="inner_page">
<div class="figure" style="text-align: center;"><img alt="images" src="Images/img01.jpg" width="80%"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_The_Republic_of_Texas.vue?b6a16da6